/*
 * BuenaVida marquee — constant-speed engine.
 *
 * The CSS animates the track by -50% over --bv-marquee-speed. If that duration
 * were fixed, adding phrases would make the band scroll FASTER (same time, more
 * distance) — confusing for a merchant. So we measure the real width of one
 * group and derive: duration = groupWidth / pxPerSec. Result: the reading speed
 * stays constant no matter how many phrases are added.
 *
 * Re-measures on resize and once webfonts land (Zolina loads late and changes
 * text width). Runs per section instance — the marquee exists on more than one
 * template, so this must NOT bail out globally.
 */
(function () {
  'use strict';

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function apply(root) {
    if (!root) return;
    var track = root.querySelector('[data-bv-marquee-track]');
    if (!track) return;

    // Reduced motion: CSS already stops the animation and wraps the text.
    if (REDUCE) return;

    var group = track.querySelector('.bv-marquee__group');
    if (!group) return;

    var width = group.getBoundingClientRect().width;
    if (!width) return; // hidden/not laid out yet

    var speed = parseFloat(root.getAttribute('data-speed')) || 40; // px per second
    var duration = width / speed;
    if (!isFinite(duration) || duration <= 0) return;

    track.style.setProperty('--bv-marquee-speed', duration.toFixed(2) + 's');
  }

  function applyAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-bv-marquee]');
    Array.prototype.forEach.call(roots, apply);
  }

  function init() {
    applyAll();

    // Webfont swap changes text width -> re-measure.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { applyAll(); }).catch(function () {});
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(function () { applyAll(); }, 150);
  });

  // Theme editor: re-measure when the section is re-rendered or selected so
  // speed/phrase/typography edits reflect live without a reload.
  document.addEventListener('shopify:section:load', function (e) { applyAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) { applyAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) { applyAll(e.target); });
})();
